import React, { useEffect, useState } from "react";
import styles from "../subscription/Subscription.module.css";
import CommonTable from "../../component/commonTable/CommonTable";
import InputText from "../../component/inputText/InputText";
import { getWebhookData, WebhookColumns } from "./SubscriptionData";
import Button from "../../component/button/Button";

function Webhooks() {
  const [webhookData, setWebhookData] = useState([]);
  const [refreshing, setRefreshing] = useState(false);
    const [loading, setLoading] = useState(false);
      const [rowsPerPage, setRowsPerPage] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
      const [totalCount, setTotalCount] = useState(0);
     const loadData = async (currentPage, rowsPerPage) => {
       setLoading(true);
       try {
         const { data, total } = await getWebhookData(currentPage, rowsPerPage);
         setWebhookData(data);
         setTotalCount(total);
       } catch (error) {
         console.error("Error fetching webhook data:", error);
       } finally {
         setLoading(false);
       }
     };
  useEffect(() => {
    loadData(currentPage, rowsPerPage);
  }, [refreshing, currentPage, rowsPerPage]);
  const url = "https://dev.api.ffmedia.tvidservices.com/api/v1/webhook/events";
  return (
    <div className={styles["tab-content"]}>
      <h2 className={styles["table-title"]}>Webhook Configuration</h2>
      <p className={styles["table-subtitle"]}>
        Configure webhook endpoints and view logs
      </p>

      <div className={styles["webhook-section"]}>
        <label htmlFor="webhookUrl">Webhook URL</label>
        <InputText
          type="text"
          id="webhookUrl"
          value={url}
          readOnly
          className={styles["input-dark"]}
        />
        <p className={styles["webhook-help"]}>
          Use this URL in your Developer Dashboard webhook configuration
        </p>
        <div className={styles["webhook-buttons"]}>
          <Button
            className={styles["refresh-btn"]}
            onClick={() => setRefreshing(!refreshing)}
            loading={loading}
          >
            ⟳ Refresh Logs
          </Button>
        </div>
      </div>

      <CommonTable
        heading={false}
        Library={"Webhook Logs"}
        data={webhookData}
        onPageChange={loadData}
        columns={WebhookColumns()}
        tableLoading={false}
        setCurrentPage={setCurrentPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        currentPage={currentPage}
        totalCount={totalCount}
      />
    </div>
  );
}

export default Webhooks;
